import { ClassNamesFromIStyles, useClassNames } from '@h2oai/ui-kit';

import { gpteInfoCardStylesDefault, IGPTeInfoCardStyles } from './GPTeInfoCard.styles';

interface IGPTeInfocardProps {
  title: string;
  data: { label: string; value: number }[];
}

const GPTeInfoCard = ({ title, data }: IGPTeInfocardProps) => {
  const classNames = useClassNames<IGPTeInfoCardStyles, ClassNamesFromIStyles<IGPTeInfoCardStyles>>(
    'gpte-info-card',
    gpteInfoCardStylesDefault
  );

  return (
    <div className={classNames.root}>
      <h2 className={classNames.header}>{title}</h2>
      <div className={classNames.content}>
        {data.map((item, index) => (
          <div className={classNames.infoItem} key={index}>
            <span className={classNames.label}>{item.label}</span>
            <span className={classNames.value}>{item.value.toLocaleString()}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GPTeInfoCard;
